import {
  AlertOutlined,
  CheckCircleOutlined,
  DatabaseOutlined,
  DollarCircleOutlined,
  FileOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import { Empty, Grid } from 'antd';
import { FC, ReactElement, useMemo } from 'react';

import styles from './EmptyTableState.module.scss';

interface Props {
  title?: string;
  description?: ReactElement | string;
  button?: ReactElement | null;
  moduleName?: 'tasks' | 'inventory' | 'alerts' | 'logs' | 'costs' | 'files';
  noFullWidth?: boolean;
}

const EmptyTableState: FC<Props> = ({ title, description, button, moduleName, noFullWidth = false }) => {
  const { lg } = Grid.useBreakpoint();

  const emptyStateIcon = useMemo(() => {
    switch (moduleName) {
      case 'costs':
        return <DollarCircleOutlined className={styles.emptyStateIconContainer} />;
      case 'tasks':
        return <UnorderedListOutlined className={styles.emptyStateIconContainer} />;
      case 'inventory':
        return <DatabaseOutlined className={styles.emptyStateIconContainer} />;
      case 'alerts':
        return <AlertOutlined className={styles.emptyStateIconContainer} />;
      case 'logs':
        return <CheckCircleOutlined className={styles.emptyStateIconContainer} />;
      case 'files':
        return <FileOutlined className={styles.emptyStateIconContainer} />;
      default:
        return Empty.PRESENTED_IMAGE_SIMPLE;
    }
  }, [moduleName]);

  return (
    <Empty
      image={emptyStateIcon}
      styles={{ image: { height: 50 } }}
      style={{
        backgroundColor: 'var(--gray-1)',
        margin: '0 auto',
        minHeight: 230,
        maxWidth: noFullWidth && lg ? '70%' : '100%',
        padding: 60,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
      description={
        <div className={styles.emptyContainer}>
          <h5 className={styles.emptyStateHeader}>{title}</h5>
          <p className={styles.emptyStateParagraph}>{description}</p>
        </div>
      }
    >
      {button}
    </Empty>
  );
};

export default EmptyTableState;
